import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { assetsService } from "../../../../api/services/assetsService";
import {
  setAllReturnAssets,
  setAllReturnAssetsLoader,
} from "../../../../infra/aggregates/myProfile/AssetsAggregates/returnAssetSlice";
interface PropsValues {
  setreturnassetData: (data: any) => void;
}
function DTOReturnedAssets({ setreturnassetData }: PropsValues) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.authSlice);
  const storeReturnAssets = useAppSelector(
    (state) => state.returnAssetSlice.returnAssets
  );
  async function getAllReturnAssets(empId: number, companyId: number) {
    dispatch(setAllReturnAssetsLoader(true));
    const response = await assetsService.getReturnAssets(empId, companyId);
    if (response) {
      dispatch(setAllReturnAssets(response?.data));
      setreturnassetData(response?.data);
      dispatch(setAllReturnAssetsLoader(false));
    } else {
      dispatch(setAllReturnAssetsLoader(false));
      return;
    }
  }
  useEffect(() => {
    if ((selector.emp_id, selector.company_id))
      getAllReturnAssets(selector.emp_id, selector.company_id);
  }, []);

  useEffect(() => {
    setreturnassetData(storeReturnAssets);
  }, [storeReturnAssets]);
  return <></>;
}
export default DTOReturnedAssets;
